import type { Mission } from '../missions.ts'

export const dfc: Mission = {
  id: "dfc",
  name: "U.S. International Development Finance Corporation",
  short: "DFC",
  call: "Development Finance",
  kind: "independent",
  url: "https://www.dfc.gov/",
  established: 2019,
  palette: {
    primary: "#041e42",
    secondary: "#1d365b",
    accent: "#bf0d3e",
  },
  colorSource: {
    kind: "site",
    url: "https://www.dfc.gov/",
  },
  motif: "globe",
  mission: {
    text: "DFC is the international investment arm of the U.S. Government. We mobilize private capital to advance U.S. foreign policy and economic development.",
    url: "https://www.dfc.gov/who-we-are/about-us",
  },
  fact: {
    text: "DFC was established in 2019 and granted significant expanded authorities in 2025.",
    url: "https://www.dfc.gov/who-we-are/about-us",
  },
  logo: {
    file: "public/logos/dfc.png",
    source: "https://commons.wikimedia.org/wiki/File:DFC_Full_Color.png",
  },
  identifier: {
    about: "https://www.dfc.gov/who-we-are/about-us",
    accessibility: "https://www.dfc.gov/accessibility-statement",
    foia: "https://www.dfc.gov/foia",
    noFear: "https://www.dfc.gov/equal-employment-opportunity",
    oig: "https://www.dfc.gov/oig",
    performance: "https://www.dfc.gov/our-impact/reports",
    privacy: "https://www.dfc.gov/privacy",
  },
}
